import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import Card from './components/AgendaContent/Card';
import config from "./Config";


if (document.body.contains(document.querySelector('.js_react_filter'))) {
  document.querySelectorAll('.js_react_filter').forEach((filter, index, array) => {
		const root = createRoot(filter);
		root.render(
				<App key={index} config={config.agenda} rootElement={filter} />
		);
  });
}

if (document.body.contains(document.querySelector('.js_react_filter_course'))) {
	document.querySelectorAll('.js_react_filter_course').forEach((filter, index, array) => {
		 const root = createRoot(filter);
		 root.render(
				 <App key={index} config={config.cursus} rootElement={filter} />
		 );
	});
 }

if (document.body.contains(document.querySelector('.js_react_tile'))) {
  	document.querySelectorAll('.js_react_tile').forEach((tile, index) => {
		const root = createRoot(tile);
    	let event = Object.values(JSON.parse(decodeURIComponent(tile.dataset.event)))[0];

		root.render(
			<Card
				key={index}
				element={event}
				config={config}
				setTagsParam={function () {
					return;
				}}
			/>
		);
  });
};

